import {BooleanUDF} from "./UDFs/BooleanUDF";
import {NumberUDF} from "./UDFs/NumberUDF";
import {StringUDF} from "./UDFs/StringUDF";

export class ReaderConfiguration {

  AutoConnect: BooleanUDF;

  BeepSoundLevel: NumberUDF;

  ConnectionAttemptsMax: NumberUDF;

  MultiplePowerDB: NumberUDF;

  PowerMode: StringUDF;

  QGeigerScan: NumberUDF;

  QMultiScan: NumberUDF;

  QSingleScan: NumberUDF;

  QWriteScan: NumberUDF;

  ReaderGeigerPower: StringUDF;

  ReaderMultiplePower: StringUDF;

  ReaderSinglePower: StringUDF;

  ReaderSingleInterval: NumberUDF;

  ReaderSoundEnabled: BooleanUDF;

  ReaderVibrateEnabled: BooleanUDF;

  ReaderWritePower: NumberUDF;

  SelectGeigerScan: StringUDF;

  SelectMultiScan: StringUDF;

  SelectSingleScan: StringUDF;

  SelectWriteScan: StringUDF;

  SessionGeigerScan: StringUDF;

  SessionMultiScan: StringUDF;

  SessionSingleScan: StringUDF;

  SessionWriteScan: StringUDF;

  TargetGeigerScan: StringUDF;

  TargetMultiScan: StringUDF;

  TargetSingleScan: StringUDF;

  TargetWriteScan: StringUDF;

  WriteAttempts: NumberUDF;

  WriteDefaultSettings: BooleanUDF;

  WriteAttemptInterval: NumberUDF;

  get(): any {
    return {
      defaultMode: 3,
      defaultScan: 2,
      ReaderGeigerPower: this.ReaderGeigerPower.value,
      ReaderMultiplePower: this.ReaderMultiplePower.value,
      ReaderSinglePower: this.ReaderSinglePower.value,
      ReaderSoundEnabled: this.ReaderSoundEnabled.value,
      ReaderVibrateEnabled: this.ReaderVibrateEnabled.value,
      ReaderSingleInterval: this.ReaderSingleInterval.value,
      ReaderWritePower: this.ReaderWritePower.value,
      qGeigerScan: this.QGeigerScan.value,
      qMultiScan: this.QMultiScan.value,
      qSingleScan: this.QSingleScan.value,
      qWriteScan: this.QWriteScan.value,
      selectGeigerScan: this.SelectGeigerScan.value,
      selectMultiScan: this.SelectMultiScan.value,
      selectSingleScan: this.SelectSingleScan.value,
      selectWriteScan: this.SelectWriteScan.value,
      sessionGeigerScan: this.SessionGeigerScan.value,
      sessionMultiScan: this.SessionMultiScan.value,
      sessionSingleScan: this.SessionSingleScan.value,
      sessionWriteScan: this.SessionWriteScan.value,
      targetGeigerScan: this.TargetGeigerScan.value,
      targetMultiScan: this.TargetMultiScan.value,
      targetSingleScan: this.TargetSingleScan.value,
      targetWriteScan: this.TargetWriteScan.value,
      WriteAttempts: this.WriteAttempts.value,
      WriteDefaultSettings: this.WriteDefaultSettings.value,
      WriteAttemptInterval: this.WriteAttemptInterval.value
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/reader.config.ts